const login = 1
const signup = 2
const verify = 3
const main = 4

export {login, signup, verify, main}